import { CalendarDayButton } from "~/components/ui/calendar"
import type { DayInfo } from "./utils"

type EventDayButtonProps = Parameters<typeof CalendarDayButton>[0] & {
  dayMap: Map<string, DayInfo>
}

export function EventDayButton({ dayMap, day, modifiers, className, ...props }: EventDayButtonProps) {
  const info = dayMap.get(day.date.toDateString())

  return (
    <>
      <CalendarDayButton day={day} modifiers={modifiers} className={`aspect-auto h-cal-row ${className ?? ""}`} {...props} />
      {info && !modifiers.selected && (
        <div className="absolute bottom-1 inset-x-0 flex justify-center">
          {info.mine && <span className="block size-1.5 rounded-full bg-primary" />}
          {info.available && !info.mine && <span className="block size-1.5 rounded-full bg-muted-foreground/50" />}
        </div>
      )}
    </>
  )
}
